import Event from "../../../../../components/categories/siakad/lms/data_event/Home";
export default function Home() {
  
  return (
    <Event />
  );
}
